@if (isPurchasing) {
  <div class="flex flex-col items-center justify-center h-96 w-full">
    <mat-spinner diameter="48"></mat-spinner>
    <span class="mt-4 text-gray-600">Processing your purchase...</span>
  </div>
} @else if (isPurchased) {
  <div class="flex flex-col items-center mt-8">
    <!-- Confirmation Icon and Message -->
    <div class="flex flex-row w-full gap-4 items-center p-2">
      <img src="assets/icons/check.svg" alt="Checkmark" class="h-25 w-15">
      <div class="flex flex-col justify-center">
        <div class="text-gray-500 text-md sm:text-sm">
          Confirmation {{ paymentResponseData?.transaction.confirmation ? "#" + paymentResponseData?.transaction.confirmation : '' }}
        </div>
        <h1 class="text-3xl sm:text-xl font-bold">Thank
          you, {{ paymentResponseData?.transaction.payer_name.split(' ')[0] }}!</h1>
      </div>
    </div>
    <!-- Order Details Card -->
    <mat-card class="w-full max-w-2xl border border-gray-200 shadow-sm mt-4">
      <mat-card-header>
        <mat-card-title class="text-lg font-semibold">Your order is confirmed</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        You'll get a confirmation email with your order number soon.
      </mat-card-content>
    </mat-card>
    <!-- Order Details Card -->
    <mat-card class="w-full max-w-2xl border mt-2 border-gray-200 shadow-sm">
      <mat-card-header>
        <mat-card-title class="text-lg font-semibold">Order details</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="grid grid-cols-2 gap-4 mt-4">
          <!-- Contact Information -->
          <div>
            <p class="font-semibold  text-gray-400">Contact information</p>
            <p class="text-md sm:text-sm">{{ loggedInAccountUser?.email }}</p>
          </div>

          <!-- Payment Method -->
          <div>
            <p class="font-semibold text-gray-400">Payment method</p>
            <div class="flex items-center align-left space-x-2">
              @switch (checkoutForm?.get('selectedCardType')?.value) {
                @case ('visa') {
                  <img src="assets/cards/visa.svg" alt="Visa" class="h-5 w-10 border-2">
                }
                @case ('mastercard') {
                  <img src="assets/cards/mastercard.svg" alt="MasterCard" class="h-5 w-10 border-2">
                }
                @case ('amex') {
                  <img src="assets/cards/amex.svg" alt="Amex" class="h-5 w-10 border-2">
                }
              }
              <p class="text-md sm:text-sm">{{ paymentResponseData?.transaction.note }}
                - {{ paymentResponseData?.transaction.amount | currency: 'USD' }}</p>
            </div>
          </div>

          <!-- Delivery Method -->
          <div>
            <p class="font-semibold text-gray-400">Delivery Method</p>
            <p class="text-md sm:text-sm">{{ paymentResponseData?.transaction.delivery_labels }}</p>
          </div>

          <!-- Billing Address -->
          <div>
            <p class="font-semibold text-gray-400">Billing address</p>
            <p class="text-md sm:text-sm">
              {{ paymentResponseData?.transaction.payer_name }}<br />
              <span
                *ngIf="paymentResponseData?.transaction.billingAddress.street_1">{{ paymentResponseData?.transaction.billingAddress.street_1 }}
                <br /></span>
              <span
                *ngIf="paymentResponseData?.transaction.billingAddress.street_2">{{ paymentResponseData?.transaction.billingAddress.street_2 }}
                <br /></span>
              {{ paymentResponseData?.transaction.billingAddress.city }}
              , {{ paymentResponseData?.transaction.billingAddress.state_abbreviation }}
              , {{ paymentResponseData?.transaction.billingAddress.zip }}<br />
              USA
            </p>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}
